import aaveV3ArbitrumErc20 from '../../../Fct/tokens/av3TokensArbitrum.json';
import aaveV3BaseErc20 from '../../../Fct/tokens/av3TokensBase.json';
import aaveV3MainnetErc20 from '../../../Fct/tokens/av3TokensMainnet.json';
import aaveV3OptimismErc20 from '../../../Fct/tokens/av3TokensOptimism.json';
export var POOL_ADDRESSES = [
    { address: '0x87870Bca3F3fD6335C3F4ce8392D69350B4fA4E2', chainId: 1 },
    { address: '0x794a61358D6845594F94dc1DB02A252b5b4814aD', chainId: 42161 },
    { address: '0x794a61358D6845594F94dc1DB02A252b5b4814aD', chainId: 10 },
    { address: '0xA238Dd80C259a72e81d7e4664a9801593F98d1c5', chainId: 8453 },
    { address: '0x6Ae43d3271ff6888e7Fc43Fd7321a503ff738951', chainId: 11155111 },
];
export var INCENTIVES_ADDRESSES = [
    { address: '0x8164Cc65827dcFe994AB23944CBC90e0aa80bFcb', chainId: 1 },
    { address: '0x929EC64c34a17401F460460D4B9390518E5B473e', chainId: 42161 },
    { address: '0x929EC64c34a17401F460460D4B9390518E5B473e', chainId: 10 },
    { address: '0xf9cc4F0D883F1a1eb2c253bdb46c254Ca51E1F44', chainId: 8453 },
    { address: '0x4DA5c4da71C5a167171cC839487536d86e083483', chainId: 11155111 },
];
export var POOL_ADDRESSES_PROVIDER_ADDRESSES = [
    { address: '0x2f39d218133AFaB8F2B819B1066c7E434Ad94E9e', chainId: 1 },
    { address: '0xa97684ead0e402dc232d5a977953df7ecbab3cdb', chainId: 42161 },
    { address: '0xa97684ead0e402dC232d5A977953DF7ECBaB3CDb', chainId: 10 },
    { address: '0xe20fCBdBfFC4Dd138cE8b2E6FBb6CB49777ad64D', chainId: 8453 },
    { address: '0x012bAC54348C0E635dCAc9D5FB99f06F24136C9A', chainId: 11155111 },
];
export var DATA_PROVIDER_ADDRESSES = [
    { address: '0x7B4EB56E7CD4b454BA8ff71E4518426369a138a3', chainId: 1 },
    { address: '0x69FA688f1Dc47d4B5d8029D5a35FB7a548310654', chainId: 42161 },
    { address: '0x69FA688f1Dc47d4B5d8029D5a35FB7a548310654', chainId: 10 },
    { address: '0x2d8A3C5677189723C4cB8873CfC9C8976FDF38Ac', chainId: 8453 },
    { address: '0x3e9708d80f7B3e43118013075F7e95CE3AB31F31', chainId: 11155111 },
];
export var A_TOKENS = {
    1: aaveV3MainnetErc20,
    42161: aaveV3ArbitrumErc20,
    10: aaveV3OptimismErc20,
    8453: aaveV3BaseErc20,
    421613: [],
    5: [],
    11155111: [],
};
